import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/ui/core";
import { useMyCommissionSummary } from "./SideCards";

/**
 * ¿Este mes cobra o no? (Anahí, 14-sep-2026.)
 *
 * «El socio es socio haciendo su recompra mensual; si no la hace, se
 * convierte en cliente. Mínimo al mes 50 puntos.» El rol de la cuenta no
 * cambia —el precio es el mismo—; lo que cambia es si cobra comisiones
 * de su red. Eso es lo que esta píldora dice, con lo que le falta y a
 * dónde ir a hacerlo.
 */
export function ActivationBadge() {
  const { t } = useTranslation();
  const summary = useMyCommissionSummary();
  const activation = summary.data?.activation;
  if (!activation) return null;

  if (activation.active) {
    return (
      <span title={t("{{pv}} de {{req}} PV en los últimos {{days}} días", { pv: activation.volumePoints, req: activation.required, days: activation.cycleDays })}>
        <Badge variant="success" size="sm">
          {t("Activo este mes · cobras comisiones")}
        </Badge>
      </span>
    );
  }

  if (!activation.membershipActive) {
    return (
      <Link to="/socio/reloj" className="inline-flex">
        <Badge variant="error" size="sm">
          {activation.membershipValidUntil
            ? t("Membresía anual vencida · renuévala para cobrar")
            : t("Sin membresía anual · actívala para cobrar")}
        </Badge>
      </Link>
    );
  }

  const faltan = Math.max(0, activation.required - activation.volumePoints);
  return (
    <Link to="/socio/reloj" className="inline-flex">
      <Badge variant="warning" size="sm">
        {t("Sin recompra este mes · te faltan {{n}} PV para cobrar", { n: faltan })}
      </Badge>
    </Link>
  );
}
